import editProfileApi from '../api/editProfileApi';
import editProfile from '../models/editProfile';
import EditProfileLookup from '../models/editProfileLookup';
import properyItemModel from '../models/properyItem';
import userProfileSummaryModel from '../models/userProfileSummary';

class EditProfileService {
  getPhotoGallery(): Promise<any> {
    return editProfileApi
      .getUserGallery()
      .then((res: any) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: {
                data: editProfile.mappingObjectsGalleries(res.data.items),
              },
            };
          }
          return { success: res.success, data: { data: [] } };
        }
        console.log('ERROR: editProfileService/getPhotoGallery:', res);
        return {
          success: res.success,
          data: { data: [] },
          message: res.data.message,
        };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/getPhotoGallery:', e);
        return { success: false, data: { data: [] }, message: e };
      });
  }

  getUserPhotos(params: any): Promise<any> {
    return editProfileApi
      .getUserPhoto(params)
      .then((res: any) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: editProfile.mappingObjectsPhoto(res.data.items),
            };
          }
          return { success: res.success, data: { data: [] } };
        }
        console.log('ERROR: editProfileService/getPhotoGallery:', res);
        return {
          success: res.success,
          data: { data: [] },
          message: res.data.message,
        };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/getPhotoGallery:', e);
        return { success: false, data: { data: [] }, message: e };
      });
  }

  patchUpdateUserPhoto(params: any): Promise<any> {
    return editProfileApi
      .patchUpdateUserPhoto(params)
      .then((res: any) => {
        if (res.success) {
          return res;
        }
        console.log('ERROR: editProfileService/patchUpdateUserPhoto:', res);
        return {
          success: res.success,
          data: { data: [] },
          message: res.data.message,
        };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/patchUpdateUserPhoto:', e);
        return { success: false, data: { data: [] }, message: e };
      });
  }

  uploadUserPhoto(params: any): Promise<any> {
    return editProfileApi
      .uploadUserPhoto(params)
      .then((res: any) => {
        if (res.success) {
          if (res.data && res.data.items) {
            return {
              success: res.success,
              data: editProfile.mappingObjectPhoto(res.data.items[0]),
            };
          }
          return res;
        }
        console.log('ERROR: editProfileService/uploadUserPhoto:', res);
        return { success: false, ...res };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/uploadUserPhoto:', e);
        return { success: false, data: { data: [] }, message: e };
        //  throw "fail";
      });
  }

  // update user profile
  updateUserProfile(params: any): Promise<any> {
    return editProfileApi
      .updateUserProfile(params)
      .then((res: any) => {
        if (res.success) {
          return {
            success: true,
            data: userProfileSummaryModel.mappingObjectCustom(res.data),
          };
          //
        }
        console.log('ERROR: editProfileService/updateUserProfile:', res);
        return {
          success: res.success,
          data: { data: [] },
          message: res.data.message,
        };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/updateUserProfile:', e);
        return { success: false, data: {}, message: e };
        //  throw "fail";
      });
  }

  // general info
  getLookUpMaritalStatus(): Promise<any> {
    return editProfileApi
      .getLookUpMaritalStatus()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpMaritalStatus:', res);
        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpMaritalStatus error:', e);
        throw new Error('failed');
      });
  }

  getLookUpSexual(): Promise<any> {
    return editProfileApi
      .getLookUpSexual()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpSexual:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpSexual error:', e);
        throw new Error('failed');
      });
  }

  getLookUpRace(): Promise<any> {
    return editProfileApi
      .getLookUpRace()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpRace:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpRace error:', e);
        throw new Error('failed');
      });
  }

  getLookUpPersonality(): Promise<any> {
    return editProfileApi
      .getLookUpPersonality()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpPersonality:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpPersonality error:', e);
        throw new Error('failed');
      });
  }

  getLookUpMyLooks(): Promise<any> {
    return editProfileApi
      .getLookUpMyLooks()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpMyLooks:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpMyLooks error:', e);
        throw new Error('failed');
      });
  }

  getLookUpBodyType(): Promise<any> {
    return editProfileApi
      .getLookUpBodyType()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpBodyType:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpBodyType error:', e);
        throw new Error('failed');
      });
  }

  getLookUpHeightCm(): Promise<any> {
    return editProfileApi
      .getLookUpHeightCm()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpHeightCm:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpHeightCm error:', e);
        throw new Error('failed');
      });
  }

  getLookUpEyeColour(): Promise<any> {
    return editProfileApi
      .getLookUpEyeColour()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpEyeColour:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpEyeColour error:', e);
        throw new Error('failed');
      });
  }

  getLookUpHairColour(): Promise<any> {
    return editProfileApi
      .getLookUpHairColour()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpHairColour:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpHairColour error:', e);
        throw new Error('failed');
      });
  }

  getLookUpHairLength(): Promise<any> {
    return editProfileApi
      .getLookUpHairLength()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpHairLength:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpHairLength error:', e);
        throw new Error('failed');
      });
  }

  getLookUpDrinking(): Promise<any> {
    return editProfileApi
      .getLookUpDrinking()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpDrinking:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpDrinking error:', e);
        throw new Error('failed');
      });
  }

  getLookUpSmoking(): Promise<any> {
    return editProfileApi
      .getLookUpSmoking()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpSmoking:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpSmoking error:', e);
        throw new Error('failed');
      });
  }

  // Intimate Info
  getLookUpSafeSex(): Promise<any> {
    return editProfileApi
      .getLookUpSafeSex()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpSafeSex:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpSafeSex error:', e);
        throw new Error('failed');
      });
  }

  getLookUpBodyHair(): Promise<any> {
    return editProfileApi
      .getLookUpBodyHair()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpBodyHair:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpBodyHair error:', e);
        throw new Error('failed');
      });
  }

  getLookUpPubicHair(): Promise<any> {
    return editProfileApi
      .getLookUpPubicHair()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpPubicHair:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpPubicHair error:', e);
        throw new Error('failed');
      });
  }

  getLookUpEndowmentLength(): Promise<any> {
    return editProfileApi
      .getLookUpEndowmentLength()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpEndowmentLength:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpEndowmentLength error:', e);
        throw new Error('failed');
      });
  }

  getLookUpEndowmentThickness(): Promise<any> {
    return editProfileApi
      .getLookUpEndowmentThickness()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpEndowmentThickness:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpEndowmentThickness error:', e);
        throw new Error('failed');
      });
  }

  getLookUpIntimatePiercing(): Promise<any> {
    return editProfileApi
      .getLookUpIntimatePiercing()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpIntimatePiercing:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpIntimatePiercing error:', e);
        throw new Error('failed');
      });
  }

  getLookUpSexualPersonality(): Promise<any> {
    return editProfileApi
      .getLookUpSexualPersonality()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpSexualPersonality:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpSexualPersonality error:', e);
        throw new Error('failed');
      });
  }

  //
  getLookUpSexualInterestSingle(): Promise<any> {
    return editProfileApi
      .getLookUpSexualInterestSingle()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpSexualInterestSingle:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpSexualInterestSingle error:', e);
        throw new Error('failed');
      });
  }

  getLookUpSexualInterestCouple(): Promise<any> {
    return editProfileApi
      .getLookUpSexualInterestCouple()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpSexualInterestCouple:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpSexualInterestCouple error:', e);
        throw new Error('failed');
      });
  }

  getLookUpGeneralInterest(): Promise<any> {
    return editProfileApi
      .getLookUpGeneralInterest()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpGeneralInterest:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpGeneralInterest error:', e);
        throw new Error('failed');
      });
  }

  getLookUpFetishInterest(): Promise<any> {
    return editProfileApi
      .getLookUpFetishInterest()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpFetishInterest:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpFetishInterest error:', e);
        throw new Error('failed');
      });
  }

  //
  getProfileBuilderPersonality(): Promise<any> {
    return editProfileApi
      .getProfileBuilderPersonality()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getProfileBuilderPersonality:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getProfileBuilderPersonality error:', e);
        throw new Error('failed');
      });
  }

  getProfileBuilderLooks(): Promise<any> {
    return editProfileApi
      .getProfileBuilderLooks()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getProfileBuilderLooks:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getProfileBuilderLooks error:', e);
        throw new Error('failed');
      });
  }

  getProfileBuilderInterest(): Promise<any> {
    return editProfileApi
      .getProfileBuilderInterest()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getProfileBuilderInterest:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getProfileBuilderInterest error:', e);
        throw new Error('failed');
      });
  }

  getProfileBuilderSeeking(): Promise<any> {
    return editProfileApi
      .getProfileBuilderSeeking()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getProfileBuilderSeeking:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getProfileBuilderSeeking error:', e);
        throw new Error('failed');
      });
  }

  // Participation
  getLookUpParticipation(): Promise<any> {
    return editProfileApi
      .getLookUpParticipation()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpParticipation:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpParticipation error:', e);
        throw new Error('failed');
      });
  }

  // Intention
  getLookUpIntention(): Promise<any> {
    return editProfileApi
      .getLookUpIntention()
      .then((res: any) => {
        if (res.success) {
          const propertyItems = properyItemModel.mappingObjects(res.data.items);
          return { success: true, data: propertyItems };
        }
        console.log('ERROR: EditProfileService/getLookUpIntention:', res);

        return res;
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookUpIntention error:', e);
        throw new Error('failed');
      });
  }

  // VerificationInfo
  getVerificationInfo(): Promise<any> {
    return editProfileApi
      .getVerificationInfo()
      .then((res: any) => {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: null };
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getVerificaiontInfo error:', e);
        throw new Error('failed');
      });
  }

  // get Lookup Data edit profile
  getLookupDatas(): Promise<any> {
    return editProfileApi
      .getLookupDatas()
      .then((res: any) => {
        if (res.success) {
          return {
            success: true,
            data: EditProfileLookup.mappingObject(res.data),
          };
        }
        return { success: false, data: null };
      })
      .catch((e: any) => {
        console.log('ERROR: EditProfileService/getLookupDatas error:', e);
        throw new Error('failed');
      });
  }

  postVerificationInfo(params: any): Promise<any> {
    return editProfileApi
      .postVerificationInfo(params)
      .then((res: any) => {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: null, message: res.message };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/postVerificationInfo:', e);
        // return {success:false, data: {data: []}, message: e};
        throw new Error('failed');
      });
  }

  makeUserMainPhoto(photoId: string | number): Promise<any> {
    return editProfileApi
      .makeUserMainPhoto(photoId)
      .then((res: any) => {
        // console.log('makeUserMainPhoto',res);
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: null };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/makeUserMainPhoto:', e);
        // return {success:false, data: {data: []}, message: e};
        throw new Error('failed');
      });
  }

  deleteRejectedPhotos(): Promise<any> {
    return editProfileApi
      .deleteRejetedPhotos()
      .then((res: any) => {
        if (res.success) {
          return { success: true, data: null };
        }
        return { success: false, data: null };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/deleteRejectedPhotos:', e);
        // return {success:false, data: {data: []}, message: e};
        throw new Error('failed');
      });
  }

  patchUserMemberType(params: any): Promise<any> {
    return editProfileApi
      .patchUserMemberType(params)
      .then((res: any) => {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: null };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/pathUserMemberType:', e);
        // return {success:false, data: {data: []}, message: e};
        throw new Error('failed');
      });
  }

  reorderUserImage(photoID: string | number, sortNumber: number): Promise<any> {
    return editProfileApi
      .reorderUserImage({ PhotoID: photoID, SortNumber: sortNumber })
      .then((res: any) => {
        // console.log({PhotoID:photoID,SortNumber:sortNumber },res)
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: null };
      })
      .catch((e: any) => {
        console.warn('ERROR: editProfileService/reorderUserImage:', e);
        // return {success:false, data: {data: []}, message: e};
        throw new Error('failed');
      });
  }
}

export default new EditProfileService();
